const websitesMapping = [
  {
    title: "Deutsch",
    url: "/de",
  },
  {
    title: "English",
    url: "/en",
  },
  {
    title: "Français",
    url: "/fr",
  },
  {
    title: "Dansk",
    url: "/dk",
  },
  {
    title: "Español",
    url: "/es",
  },
]

module.exports = {
  websitesMapping: websitesMapping,
}
